import { render, staticRenderFns } from "./ViewStockMovementComponent.vue?vue&type=template&id=55a220d0"
import script from "./ViewStockMovementComponent.vue?vue&type=script&lang=js"
export * from "./ViewStockMovementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports